import CustomSegment from '@/components/CustomSegment';
import PageTitle from '@/components/PageTitle';
import { useSegment } from '@/hooks/useSegment';
import DashboardLayout from '@/layouts/DashboardLayout';
import type { SegmentedType } from '@/types/global.types';
import AssessmentsScores from './_components/AssessmentsScores';
import Filters from './_components/Filters';
import AssessmentsList from './AssessmentsList';

type AssessmentsSegmentType = 'assessments-list' | 'assessments-scores';

export default function Assessments() {
  const { segment, setSegment } = useSegment<AssessmentsSegmentType>(
    'recruitment-assessments',
    'assessments-list',
    false,
  );

  const SEGMENT_CONFIG: SegmentedType<AssessmentsSegmentType>[] = [
    {
      value: 'assessments-list',
      label: 'List',
      view: <AssessmentsList />,
    },
    {
      value: 'assessments-scores',
      label: 'Scores',
      view: <AssessmentsScores />,
    },
  ];

  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Assessments">
      <PageTitle
        classNames={{ root: 'items-start' }}
        title="Assessments"
        items={[
          { title: 'Dashboard', path: '/admin/recruitment/dashboard' },
          { title: currentSegment?.label },
        ]}
      >
        <Filters type={segment} />
      </PageTitle>

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
}
